import { T, F } from './tokens';

interface PersonaCardProps {
  name: string;
  archetype: string;
  color: string;
  selected?: boolean;
  onSelect?: () => void;
  score?: number;
  flagged?: number;
  compact?: boolean;
}

export function PersonaCard({
  name, archetype, color, selected, onSelect, score, flagged, compact,
}: PersonaCardProps) {
  return (
    <div
      onClick={onSelect}
      style={{
        display: 'flex', alignItems: 'center', gap: 12,
        padding: compact ? '10px 16px' : '14px 16px',
        background: selected ? T.bgCard : T.bgSoft,
        borderRadius: T.radius.md,
        border: selected ? `1.5px solid ${color}` : `1px solid ${T.border}`,
        boxShadow: selected ? T.shadowMd : 'none',
        cursor: onSelect ? 'pointer' : 'default',
        transition: 'all 0.2s',
        margin: '0 0 8px',
      }}
    >
      <div style={{
        width: 3, height: compact ? 32 : 36,
        borderRadius: 2, background: color, flexShrink: 0,
      }} />
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: T.text, fontFamily: F.body }}>
          {name}
        </div>
        <div style={{ fontSize: 11, color: T.textMuted, fontFamily: F.body }}>
          {archetype}
        </div>
      </div>
      {flagged != null && flagged > 0 && (
        <span style={{
          fontSize: 10, padding: '3px 8px', borderRadius: 99,
          background: T.dangerSoft, color: T.danger,
          fontFamily: F.mono, fontWeight: 600,
        }}>
          {flagged} flagged
        </span>
      )}
      {score != null && (
        <div style={{ textAlign: 'right' }}>
          <div style={{
            fontSize: 18, fontFamily: F.mono, fontWeight: 700,
            color: score >= 70 ? T.success : T.danger,
          }}>
            {score}%
          </div>
          <span style={{
            fontSize: 9, padding: '2px 6px', borderRadius: 99,
            background: score >= 70 ? T.successSoft : T.dangerSoft,
            color: score >= 70 ? T.success : T.danger,
            fontFamily: F.mono, fontWeight: 600,
          }}>
            {score >= 70 ? 'PASS' : 'FAIL'}
          </span>
        </div>
      )}
    </div>
  );
}
